import React from 'react';
import { Loader, LightChip, SessionNoteModalBody, useClinicalNotesModal } from '@uplift/ui-v2';
import { useAddendaBySessionIdQuery, useAppointmentByIdQuery, useSessionByAppointmentIdQuery } from '@uplift/queries';


export const AddendaTitleChip: React.VFC<{ sessionId: string }> = (props) => {
  const { data } = useAddendaBySessionIdQuery(props.sessionId);

  if (data?.length) {
    if (data?.length > 1) {
      return <LightChip label="with Addenda" size="small" color="lightGrey" labelWeight="thin" />;
    }
    return <LightChip label="with Addendum" size="small" color="lightGrey" labelWeight="thin" />;
  }

  return null;
};


export type SessionClinicalNotesReviewProps = {
  appointmentId: string;
  patientId?: string;
  showPatientTitle?: boolean;
};


export const SessionClinicalNotesReview: React.FC<SessionClinicalNotesReviewProps> = (props) => {
  const { data: session } = useSessionByAppointmentIdQuery(props.appointmentId);
  const { data: appointment } = useAppointmentByIdQuery(props.appointmentId);
  const { state } = useClinicalNotesModal(appointment, session);

  if (!state || !session || !appointment) return <Loader />;

  return (
    <SessionNoteModalBody
      state={state}
      session={session}
      appointment={appointment}
      showPatientTitle={props.showPatientTitle}
    />
  );
};
